import { createStore } from 'vuex'

export default createStore({
  state: {
    isLoggedIn: false,
    userDetails: null,

    isSideNavOpen: true,

    customer: null,

    product: null,

    loan: null,

    role: null,

    user: null,

    transaction: null,

    paymentAccount: null,

    accessRule: null,

    repaymentReminder: null,

    permissions: null,

    makerCheckerConfig: null,

    makerCheckerRequest: null,

    securityQuestion: null,

    appVersionPolicy: null,

    device: null,

    username: null,

    password: null,

    onboarding: null
  },
  getters: {
    getOnboarding: (state) => state.onboarding,

    getPassword: (state) => state.username,
    
    getUsername: (state) => state.username,

    getDevice: (state) => state.device,

    getAppVersionPolicy: (state) => state.appVersionPolicy,

    getSecurityQuestion: (state) => state.securityQuestion,

    getMakerCheckerRequest: (state) => state.makerCheckerRequest,

    getMakerCheckerConfig: (state) => state.makerCheckerConfig,

    getPermissions: (state) => state.permissions,

    getRepaymentReminder: (state) => state.repaymentReminder,

    getAccessRule: (state) => state.accessRule,

    getTransaction: (state) => state.transaction,

    getPaymentAccount: (state) => state.paymentAccount,

    getUser: (state) => state.user,

    getRole: (state) => state.role,

    getLoan: (state) => state.loan,

    getProduct: (state) => state.product,

    getCustomer: (state) => state.customer,

    getIsLoggedIn: (state) => state.isLoggedIn,

    getUserDetails: (state) => state.userDetails,

    getIsSideNavOpen: (state) => state.isSideNavOpen
  },
  mutations: {
    setOnboarding(state, value) {
      state.onboarding = value
    },

    setUsername(state, value) {
      state.username = value
    },

    setDevice(state, value) {
      state.device = value
    },

    setAppVersionPolicy(state, value) {
      state.appVersionPolicy = value
    },

    setSecurityQuestion(state, value) {
      state.securityQuestion = value
    },

    setMakerCheckerRequest(state, value) {
      state.makerCheckerRequest = value
    },

    setMakerCheckerConfig(state, value) {
      state.makerCheckerConfig = value
    },

    setPermissions(state, value) {
      state.permissions = value
    },

    setRepaymentReminder(state, value) {
      state.repaymentReminder = value
    },

    setAccessRule(state, value) {
      state.accessRule = value
    },

    setPaymentAccount(state, value) {
      state.paymentAccount = value
    },

    setTransaction(state, value) {
      state.transaction = value
    },

    setUser(state, value) {
      state.user = value
    },

    setRole(state, value) {
      state.role = value
    },

    setLoan(state, value) {
      state.loan = value
    },

    setProduct(state, value) {
      state.product = value
    },

    setCustomer(state, value) {
      state.customer = value
    },

    setUserDetails(state, value) {
      state.userDetails = value
    },

    setIsLoggedIn(state, value) {
      state.isLoggedIn = value
    },

    setIsSideNavOpen(state, value) {
      state.isSideNavOpen = value
    }
  },
  actions: {
  },
  modules: {
  }
})
